export default function (x) {
  return ("0" + x).slice(-2);
}
